import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UdexEventTypeService {
  constructor() {}

  preventEventDefault($event: any): void {
    $event.detail.originalEvent.preventDefault();
  }
}
